import { createContext } from "react";

import { UserDataContext } from "../types";

export const initialContextData: UserDataContext = {
  isUserDataFetching: false,
  userDataQueryStatus: "idle",
  userDetails: null,
  currentGroup: null,
  currentAchievements: null,
  groups: [],
  changeGroup: notImplemented,
};

export const userDataContext = createContext<UserDataContext>(
  initialContextData
);

function notImplemented(): never {
  throw new Error("Missing UserDataProvider");
}
